import chatbotRequest from '@/service/channel/http'
import type { UploadFileReq, UploadFileRes } from '../type/uploadFile'

export function uploadFileApi(params: UploadFileReq): Promise<UploadFileRes> {
    const formData = new FormData()
    formData.append('file', params.file)
    formData.append('model', params.model)
    formData.append('format', params.format)
    formData.append('action', params.action)

    return chatbotRequest<UploadFileRes, FormData, UploadFileRes>({
        url: '/api/common/upload/file',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}